import React, { useState } from "react";
// import about1 from "../../../images/about/img-01.png";
// import about2 from "../../../images/about/img-02.png";
// import about3 from "../../../images/about/img-03.png";
import about1 from "../../../images/about/About_Us.png";
import about2 from "../../../images/about/Mission.png";
import about3 from "../../../images/about/Vision.png";
import aIcon1 from "../../../images/icon/about-icon01.png";
import aIcon2 from "../../../images/icon/about-icon02.png";
import aIcon3 from "../../../images/icon/about-icon03.png";

const About = () => {
  const [activeIndex, setActiveIndex] = useState(2);

  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  const aboutItems = [
    {
      img: about1,
      icon: aIcon1,
      heading: "About us",
      content:
        "At Anantkamal Studios, we’ve been more than just a software company—we’re your strategic partner in digital transformation. Since 1997, we've empowered startups, growing businesses, and global enterprises with cutting-edge software engineering, innovative design, and intelligent automation.",
    },
    {
      img: about2,
      icon: aIcon2,
      heading: "Our mission",
      content:
        "To empower businesses through innovative technology, creative branding, and automated systems, driving scalable growth, efficiency, and long-term success.",
    },
    {
      img: about3,
      icon: aIcon3,
      heading: "Our vision",
      content:
        "To become a globally trusted technology partner, transforming industries by blending human creativity with digital intelligence.",
    },
  ];

  return (
    <section className="about pb-140">
      <div className="container">
        <div className="about-wrap mt-none-30 ul_li_between">
          {aboutItems.map((item, index) => (
            <div
              key={index}
              className={`about-item mt-30 xb-mouseenter wow fadeInUp ${
                activeIndex === index ? "active" : ""
              }`}
              data-wow-delay={`${index * 150}ms`}
              data-wow-duration="600ms"
              onMouseEnter={() => handleMouseEnter(index)}
            >
              <div>
                <div className="xb-item--img">
                  <img src={item.img} alt="" />
                </div>
                <h3 className="xb-item--heading">
                  <span>
                    <img src={item.icon} alt="" />
                  </span>
                  {item.heading}
                </h3>
                <div className="xb-item--holder">
                  <h3 className="xb-item--title">
                    <span>
                      <img src={item.icon} alt="" />
                    </span>
                    {item.heading}
                  </h3>
                  <p className="xb-item--content">{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
